<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col">
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Modificar usuario</h4>
                </div>

                <div>
                  <button @click="volver" class="btn btn-danger">
                    <!-- <i class="fas fa-user-plus"></i> -->
                    Volver
                  </button>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row">
                <div v-if="!isLoading" class="col">
                  <form
                    @submit.prevent="submit"
                    v-promise-btn="{ action: 'submit' }"
                    ref="form"
                  >
                    <div class="container">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Nombre_Usuario" class="label">
                              Nombre de usuario
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="nombre de usuario"
                              id="Nombre_Usuario"
                              v-model="usuario.nom_usuario"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="contrasena" class="label">
                              Contraseña
                            </label>

                            <div class="input-group">
                              <input
                                :type="showPassword ? 'text' : 'password'"
                                class="form-control"
                                name="contraseña"
                                id="contrasena"
                                v-model="usuario.contrasena"
                              />

                              <div class="input-group-addon">
                                <a @click="changeShowPassword">
                                  <i
                                    :class="`fa fa-eye${
                                      !showPassword ? '' : '-slash'
                                    }`"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Apellido" class="label">Apellido</label>

                            <input
                              type="text"
                              class="form-control"
                              name="apellido"
                              id="Apellido"
                              v-model="usuario.apellido"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Nombre" class="label">Nombre</label>

                            <input
                              type="text"
                              class="form-control"
                              name="nombre"
                              id="Nombre"
                              v-model="usuario.nombre"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="DNI" class="label">DNI</label>

                            <input
                              type="text"
                              class="form-control"
                              name="DNI"
                              id="DNI"
                              v-model="usuario.DNI"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="tel-fijo" class="label">
                              Telefono Fijo
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="telefono fijo"
                              id="tel-fijo"
                              v-model="usuario.tel_fijo"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Cel-empresa" class="label">
                              Celular empresa
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="celular empresa"
                              id="Cel-empresa"
                              v-model="usuario.Tel_celular_empresa"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Cel-personal" class="label">
                              Celular personal
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="celular personal"
                              id="Cel-personal"
                              v-model="usuario.tel_cel_personal"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Provincia" class="label">
                              Provincia
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="Provincia"
                              id="Provincia"
                              v-model="usuario.domicilio_prov"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Cuidad" class="label">Ciudad</label>

                            <input
                              type="text"
                              class="form-control"
                              name="cuidad"
                              id="Ciudad"
                              v-model="usuario.domic_ciudad"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="Direccion" class="label">
                              Dirección
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="Direccion"
                              id="Direccion"
                              v-model="usuario.domic_calleYnum"
                            />
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="info-extra" class="label">
                              Info extra de direccion
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              name="info extra"
                              id="info-extra"
                              v-model="usuario.domic_infoExtra"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="w-100 d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="volver"
                      >
                        Cancelar
                      </button>

                      <button type="submit" class="btn btn-primary">
                        Guardar
                      </button>
                    </div>
                  </form>
                </div>

                <div v-else class="col">...Cargando...</div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "lodash-es";

export default {
  name: "ModificarUsuario",
  mounted() {
    this.isLoading = true;
    this.usuarioId = this.$router.currentRoute.params.id_usuario;
    this.getData().then((data) => {
      if (!data.ok) {
        this.$msgBoxOk(data.message);
      }
      this.isLoading = false;
    });
  },
  computed: {},
  data: () => ({
    isLoading: true,
    showPassword: false,
    usuario: {
      nom_usuario: null,
      contrasena: null,
      nombre: null,
      apellido: null,
      DNI: "",
      tel_fijo: "",
      Tel_celular_empresa: "",
      tel_cel_personal: "",
      domicilio_prov: "",
      domic_ciudad: "",
      domic_calleYnum: "",
      domic_infoExtra: "",
    },
    usuarioId: null,
  }),

  methods: {
    changeShowPassword() {
      this.showPassword = !this.showPassword;
    },
    volver() {
      this.$router.push(`/admin/users/`);
    },
    async getData() {
      const resp = await axios.post(`/execute`, {
        method: "SEC.GetUsuarioById",
        parameters: [{ name: "id_usuario", value: this.usuarioId }],
      });
      if (resp.data.ok) {
        const usuarioData = get(resp, "data.result[0][0]", {});
        (this.usuario.nom_usuario = usuarioData.NomUsuario),
          (this.usuario.contrasena = usuarioData.contrasena),
          (this.usuario.nombre = usuarioData.nombre),
          (this.usuario.apellido = usuarioData.apellido),
          (this.usuario.DNI = usuarioData.DNI),
          (this.usuario.tel_fijo = usuarioData.tel_fijo),
          (this.usuario.Tel_celular_empresa = usuarioData.Tel_celular_empresa),
          (this.usuario.tel_cel_personal = usuarioData.tel_cel_personal),
          (this.usuario.domic_ciudad = usuarioData.domic_ciudad),
          (this.usuario.domicilio_prov = usuarioData.domicilio_prov),
          (this.usuario.domic_calleYnum = usuarioData.domic_calleYnum),
          (this.usuario.domic_infoExtra = usuarioData.domic_infoExtra);
      }
      return resp.data;
    },
    async submit() {
      if (!this.isValidNewForm()) {
        alert("Por favor, complete los campos correctamente");
        return;
      }

      try {
        const resp = await axios.post(`/execute`, {
          method: "SEC.ModificarUsuario",
          parameters: [
            { name: "id_usuario", value: this.usuarioId },
            { name: "nom_usuario", value: this.usuario.nom_usuario },
            { name: "contrasena", value: this.usuario.contrasena },
            { name: "nombre", value: this.usuario.nombre },
            { name: "apellido", value: this.usuario.apellido },
            { name: "DNI", value: this.usuario.DNI },
            { name: "tel_fijo", value: this.usuario.tel_fijo },
            {
              name: "Tel_celular_empresa",
              value: this.usuario.Tel_celular_empresa,
            },
            { name: "tel_cel_personal", value: this.usuario.tel_cel_personal },
            { name: "domicilio_prov", value: this.usuario.domicilio_prov },
            { name: "domic_ciudad", value: this.usuario.domic_ciudad },
            { name: "domic_calleYnum", value: this.usuario.domic_calleYnum },
            { name: "domic_infoExtra", value: this.usuario.domic_infoExtra },
          ],
        });
        if (resp.data.ok) {
          this.$bvToast.toast(resp.data.message, {
            variant: "success",
          });
          this.volver();
        }
      } catch (error) {
        console.error("Error al modificar usuario:", error);
        this.$bvToast.toast(
          "Error al modificar usuario. Inténtelo nuevamente.",
          {
            variant: "danger",
          },
        );
      }
    },
    isValidNewForm() {
      return (
        this.usuario.nom_usuario !== null &&
        this.usuario.contrasena !== null &&
        this.usuario.nombre !== null &&
        this.usuario.apellido !== null
      );
    },
  },
};
</script>

<style scoped></style>
